import { connect } from 'react-redux';
import DefaultValueProps from './ValueProps';

const mapStateToProps = ({
  system: { isTablet }
}) => ({
  isTablet
});

const ValueProps = connect(mapStateToProps, null)(DefaultValueProps);

export { default as OverlappingValueProps } from './OverlappingValueProps';
export { ValueProps };
